import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIconDefinition, IconName, library } from '@fortawesome/fontawesome-svg-core';
import * as React from 'react';
import { CardWidget } from './CardWidget';
import { CardGridWidget } from './CardGridWidget';

library.add(fas);
export const DocsCardGrid: React.FC<React.PropsWithChildren> = ({ children }) => (
  <CardGridWidget columns={2} gap={14}>
    {children}
  </CardGridWidget>
);

interface DocsCardProps {
  children?: React.ReactNode;
  href: string;
  icon?: IconName;
  label?: string;
  title: string;
}

export const DocsCard: React.FC<DocsCardProps> = ({ children, href, icon, label, title }) => {
  const definition = icon ? findIconDefinition({ prefix: 'fas', iconName: icon }) : undefined;
  const external = !href.startsWith('#') && !(href.startsWith('/') && !href.startsWith('//'));
  return (
    <CardWidget
      compact
      href={href}
      target={external ? '_blank' : undefined}
      title={title}
      metadata={label}
      description={children}
      icon={definition ? <FontAwesomeIcon icon={definition} /> : undefined}
    />
  );
};
